<template>
  <Card
    tone="default"
    padding="md"
    class="flex h-full flex-col gap-3 focus-visible:shadow-md hover:shadow-md hover:shadow-accent/50"
    data-testid="module-card"
    @click="$emit('open')"
    @keydown.enter.prevent="$emit('open')"
    @keydown.space.prevent="$emit('open')"
  >
    <div class="flex items-start justify-between gap-2">
      <div
        class="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-accent-soft text-accent-strong"
      >
        <BaseIcon :name="icon" :size="18" />
      </div>
      <BaseTag v-if="status !== 'ready'" :tone="statusTone" :label="statusLabel" />
    </div>
    <h3 class="text-base font-bold text-ink-strong">{{ title }}</h3>
    <p class="text-sm text-ink-muted">{{ description }}</p>
  </Card>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Card from '@/components/primitives/Card.vue';
import BaseTag from '@/components/base/BaseTag.vue';
import BaseIcon from '@/components/base/BaseIcon.vue';
import type { IconName } from '@/components/base/icons';
import type { ModuleStatus } from '@/types/component-types';

export type { ModuleStatus } from '@/types/component-types';

interface Props {
  title: string;
  description: string;
  status: ModuleStatus;
  statusLabel: string;
  icon?: IconName;
}

const props = withDefaults(defineProps<Props>(), {
  icon: 'success',
});

defineEmits<{
  (e: 'open'): void;
}>();

const statusTone = computed<'success' | 'accent' | 'default'>(() => {
  switch (props.status) {
    case 'ready':
      return 'success';
    case 'beta':
      return 'accent';
    case 'planned':
    default:
      return 'default';
  }
});
</script>
